<template>
    <ul ref="images" style="display:none">
        <li v-for="(img, index) in images" :key="index"><img :src="img.src" alt="Picture 1"></li>
    </ul>
</template>

<script>
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
export default {
  name: 'jc-preview',
  props: {
    images: {
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    images: {
      deep: true,
      handler () {
        if (this.images) {
          this.$nextTick(() => this.init())
        }
      }
    }
  },
  methods: {
    init () {
      if (this.gallery) {
        this.gallery.update()
      } else {
        this.gallery = new Viewer(this.$refs.images)
      }
    }
  },
  beforeDestroy () {
    if (this.gallery) this.gallery.destroy()
  },
  mounted () {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/preview/index.vue